import React, { Component } from "react";
import {AppBar, Toolbar, IconButton} from "@material-ui/core";
import Menu from "@material-ui/icons/Menu"
import logo from "../../common/assets/logo.png";
import { withTheme } from '@material-ui/core/styles';
class Header extends Component {
  render() {
    const {theme, leftIconClick, login} = this.props
    return (
      <AppBar
        style={theme.appBar.root}
        // onLeftIconButtonTouchTap={this.props.leftIconClick}
        // iconStyleLeft={{
        //   color: "#1bb6b1",
        //   display: !this.props.login ? "block" : "none",
        //   marginLeft: 5,
        //   marginRight: 0,
        //   marginTop: 0
        // }}
        // titleStyle={styles.title}
        // title={<img src={logo} className="App-logo" alt="logo" />}
      >
        <Toolbar position="sticky" style={theme.appBar.toolbar}>
          <IconButton onClick={leftIconClick} style={{display: !login ? "block" : "none"}}>
            <Menu style={theme.appBar.leftIcon}/>
          </IconButton> 
          <img src={logo} style={theme.logo}  alt="logo" />
        </Toolbar>       
      </AppBar>
    );
  }
}


export default withTheme(Header)



// WEBPACK FOOTER //
// ./src/components/Header/Header.js